module.exports = {
	free:{
		questionsInSetLimit:5,
		disableTemplates:false,
		disableImageSearch:true,
		scoreSheetDisable90Day:true,
		scoreSheetDisableCustom:true	
	},
	plus:{
		questionsInSetLimit:null,
		disableTemplates:false,
		disableImageSearch:false,
		scoreSheetDisable90Day:false,
		scoreSheetDisableCustom:false	
	},

}




// WEBPACK FOOTER //
// ./src/planRestrictions.js